<template>
  <div class="adminPage">
    <div class="titlePage">
      Importación de archivo Certificaciones masivas
    </div>

    <span class="sectionLabel">
      Seleccionar archivo de Certificación masiva
    </span>

    <div class="adminCard">
      <Formulario
        :FieldsForm="Formulario.fields1"
        :method="executeProcess"
      />

      <div id="div_Respuesta" class="responseArea"></div>

      <div class="tableCard">
        <DataTableGrades
          :InfoView="DLXertify"
          :HeadTable="HDXertify"
          v-if="renderComponent1"
        />
      </div>

      <span class="helpLink">
        <a
          href="https://services.ibero.edu.co/Files/ManualCargueMasivo.pdf"
          target="_blank"
        >
          Necesita ayuda haga click aqui
        </a>
      </span>
    </div>
  </div>
</template>
<script>
import Formulario from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTableGrades from '@/components/data-tables/DataLoadXertify.vue'

export default {
  name: 'BulkCertificate',
  components: {
    Formulario,
    DataTableGrades,
  },
  data () {
    return {
      resultad : '',
      IdLoad : '',
      labelFields: {
        fields1: 'Importación de archivo',
      },
      Formulario: {
        fields1: [
          {
            id: 'IdFile',
            placeholder: 'Examinar',
            type: 'file',
            values: '',
            validate: {
              required: false,
            },
            class: 'col-md-6',
          },
          {
            id: 'IdProcessFile',
            type: 'button',
            placeholder: 'Validacion Data',
            class: 'col-md-3',
          },
          {
            id: 'IdProcessCerti',
            type: 'button',
            placeholder: 'Procesar Certificaciones',
            class: 'col-md-3',
            disabled: true,
          },
          {
            id: 'IdTextFind',
            model: 'IdTextFind',
            type: 'html',
            values: '',
            class: 'col-md-12',
          },
        ],
      },
      File_id : '',
      formUserFileModel: [],
      HDXertify: [
        {
          id: 'id',
          model: 'id',
          name: 'id',
          type: 'input',
          placeholder: 'id',
          values: '',
          class: 'col-md-4',
        },
        {
          id: 'Codigo_Certificado',
          model: 'Codigo_Certificado',
          name: 'Codigo_Certificado',
          type: 'input',
          placeholder: 'Codigo Xertify',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'Certificado',
          model: 'Certificado',
          name: 'Certificado',
          type: 'input',
          placeholder: 'Certificado',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'Documento',
          model: 'Documento',
          name: 'Documento',
          type: 'input',
          placeholder: 'Numero Identificacion',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'Estudiante',
          model: 'Estudiante',
          name: 'Estudiante',
          type: 'input',
          placeholder: 'Estudiante',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'email',
          model: 'email',
          name: 'email',
          type: 'input',
          placeholder: 'Correo',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'Periodo',
          model: 'Periodo',
          name: 'Periodo',
          type: 'input',
          placeholder: 'Periodo',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'Homologado',
          model: 'Homologado',
          name: 'Homologado',
          type: 'input',
          placeholder: 'Homologado',
          class: 'col-md-4',
        },
        {
          id: 'Renovado',
          model: 'Renovado',
          name: 'Renovado',
          type: 'input',
          placeholder: 'Renovado',
          class: 'col-md-4',
          values: '',
        },
        {
          id: 'Estado',
          model: 'Estado',
          name: 'Estado',
          type: 'input',
          placeholder: 'Estado Certificado',
          class: 'col-md-4',
          values: '',
        },
      ],
      DLXertify: [],
      renderComponent1: false,
      renderComponent2: false,
      addRExito: false,
      UpdRExito: false,
      isNew: false,
    }
  }, 
  methods: {
    valdate (infoDat) {
      return IberoHelpers.dataObjDate(infoDat)
    },
    cleantable(){

    },
    searchForm () {
      this.DLXertify = []
      this.isNew = false
      var ListCertifcate = IberoHelpers.getBulkXertifyList(this.$store, JSON.parse(this.File_id)[0].Id_File)
      this.renderComponent1 = false
      ListCertifcate.then(Response => {
        if ((Response.data === undefined) || (Response.data === '')) {
            this.DLXertify = []
        } else {
          if (Array.isArray(Response.data)) {
            this.DLXertify = Response.data
          } else {
            this.DLXertify = [Response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
      })
    },
    executeProcess: function (event) {
      switch (event.target.id) {
        case 'IdFile':
          document.getElementById('div_Respuesta').innerHTML = ''
           document.getElementById('btn_IdProcessCerti').style.display = 'none'
          this.formUserFileModel = []
          if (
            event.target.files[0].name
              .split('.')
              .pop()
              .indexOf('xls') === 0
          ) {
            event.target.nextElementSibling.innerText = event.target.files[0].name

            this.formUserFileModel.push({ filedata: event.target.files[0] })
          } else {
            alert('El archivo cargado no es valido.')
          }
          break
        case 'btn_IdProcessFile':
            this.DLXertify = []
            try{
              if (this.formUserFileModel.length > 0) {
                var datenow =  Date.now()
                //offset = offset.toISOString().split('T')[0]

                var fileName = "Certificaciones_" + datenow + ".xls"
                
                var dataFile = IberoHelpers.sendUpdloadFileChangeName(
                  this.$store,
                  this.formUserFileModel,
                  'BULKCERTIFICATE',
                  fileName,
                  0
                )
                document.getElementById('IdFile').nextElementSibling.innerText =
                  'Procesando.....'
                dataFile.then(Response => {
                  if (
                    Response !== false &&
                    Response[0].wsDocument.data.id_File !== undefined
                  ) {
                    this.File_id = Response[0].wsDocument.data.id_File
                    
                    dataFile = IberoHelpers.processBulkCertificate(
                      this.$store,
                      JSON.parse(Response[0].wsDocument.data.id_File)[0]
                    )
                    dataFile.then(Response => {
                      if (Response !== false) {
                        this.formUserFileModel = []
                        this.resultad = ''
                        this.resultad = JSON.parse(Response.data.message)
                        console.log(Response.data.message)
                          console.log(this.resultad)
                        if ((Response.data.message !== '') && (this.resultad === "Data Validada")) {
                          try {
                                var sTable =
                                "<div class='alert alert-success' role='alert'>" +
                                'Archivo Validado Correctamente.' +
                                '</div> '
                              this.searchForm()
                            document.getElementById('IdFile').nextElementSibling.innerText = ''
                            document.getElementById('btn_IdProcessCerti').style.display = 'block'
                            this.Formulario.fields1.values = ''
                          } catch (error) {
                            sTable =
                            "<table class='table table-hover' id='myTable2' ref='table'>" +
                            '       <thead>' +
                            '         <tr>' +
                            "           <th scope='col'>Respuesta</th>" +
                            '         </tr>' +
                            '       </thead>' +
                            '       <tbody> ' +
                            '<tr> <td>' + error + '</td></tr>' +
                            '</tbody> </table>'
                            document.getElementById('IdFile').nextElementSibling.innerText = ''
                            this.Formulario.fields1.values = ''
                            this.DLXertify = []
                            this.HDXertify = []
                          }
                        }
                          else
                          {
                            var sTable =
                                "<div class='alert alert-danger' role='alert'>" +
                                this.resultad +
                                '</div> '
                              document.getElementById('IdFile').nextElementSibling.innerText = ''
                              this.Formulario.fields1.values = ''
                              this.HDXertify = []
                              this.DLXertify = []
                          }
                        
                      } else {
                        alert(
                          'No es posible procesar el archivo error de conexión !!!'
                        )
                         document.getElementById('IdFile').nextElementSibling.innerText = ''
                          this.Formulario.fields1.values = ''
                      }
                      document.getElementById('div_Respuesta').innerHTML = sTable

                    })
                  } else {
                    alert(
                      'No es posible cargar el archivo al sistema error de conexión !!!'
                    )
                    document.getElementById('IdFile').nextElementSibling.innerText = ''
                    this.Formulario.fields1.values = ''
                  }
                })
              } else {
                alert('No ha cargado ningun archivo para validar.')
                document.getElementById('IdFile').nextElementSibling.innerText = ''
                this.Formulario.fields1.values = ''
              }
            }
            catch
            {
                alert('No es posible cargar el archivo al sistema error de conexión !!!')
                document.getElementById('IdFile').nextElementSibling.innerText = ''
                this.Formulario.fields1.values = ''
                this.DLXertify = []
            }
          break
        case 'btn_IdProcessCerti':
            if (this.resultad === 'Data Validada')
            {
              debugger
              let loader = this.$loading.show()
                document.getElementById('btn_IdProcessFile').style.display = 'block'
                var dataFile2 = IberoHelpers.sendBulkXertify(
                  this.$store,
                  JSON.parse(this.File_id)[0].Id_File
                )
                document.getElementById('IdFile').nextElementSibling.innerText =
                  'Procesando.....'
                  var sTable =
                            "<div class='alert alert-warning' role='alert'>" +
                            'Procesando.....' +
                            '</div> '
                 document.getElementById('div_Respuesta').innerHTML = sTable

                dataFile2.then(Response => {
                  if (Response !== false) {
                    this.formUserFileModel = []
                    if ((Response.data === "Procesado")) {
                      try {
                            var sTable =
                            "<div class='alert alert-success' role='alert'>" +
                            'Archivo Procesado Correctamente.' +
                            '</div> '
                          this.searchForm()
                          document.getElementById('btn_IdProcessFile').style.display = 'block'
                         document.getElementById('btn_IdProcessCerti').style.display = 'block'
                      } catch (error) {
                        sTable =
                        this.DLXertify.hide()
                        "<table class='table table-hover' id='myTable2' ref='table'>" +
                        '       <thead>' +
                        '         <tr>' +
                        "           <th scope='col'>Respuesta</th>" +
                        '         </tr>' +
                        '       </thead>' +
                        '       <tbody> ' +
                        '<tr> <td>Fallo en la generacion </td></tr>' +
                        '</tbody> </table>'
                      }
                    }
                      else
                      {
                        var sTable =
                            "<div class='alert alert-danger' role='alert'>" +
                            JSON.parse(Response.data) +
                            '</div> '
                            this.DLXertify.hide()
                         document.getElementById('btn_IdProcessFile').style.display = 'block'
                            document.getElementById('btn_IdProcessCerti').style.display = 'none'
                      }
                    
                  } else {
                    alert(
                      'No es posible procesar el archivo error de conexión !!!'
                    )
                  }
                  document.getElementById('div_Respuesta').innerHTML = sTable
                  document.getElementById('IdFile').nextElementSibling.innerText = ''
                  this.Formulario.fields1.id_File = null
                })
                loader.hide()
            }
            else
            {
                alert('No ha cargado ningun archivo para procesar.')
            }
            break
      }
    },
  },
}
</script>